export { CircularGauge } from './CircularGauge';
